import { PipelineContext34fsb0mycu471 as PipelineContext } from './PipelineContext.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *proceedLoop($this, $completion) {
  $l$loop_0: do {
    var index = $this.n4r_1;
    if (index === -1) {
      break $l$loop_0;
    }
    var interceptors = $this.k4r_1;
    if (index >= interceptors.q2()) {
      $this.o4r();
      break $l$loop_0;
    }
    var executeInterceptor = interceptors.r2(index);
    $this.n4r_1 = index + 1 | 0;
    yield* executeInterceptor($this, $this.m4r_1, $completion);
  }
   while (true);
  return $this.m4r_1;
}
var DebugPipelineContextClass;
function DebugPipelineContext() {
  if (DebugPipelineContextClass === VOID) {
    class $ extends PipelineContext() {
      constructor(context, interceptors, subject, coroutineContext) {
        super(context);
        this.k4r_1 = interceptors;
        this.l4r_1 = coroutineContext;
        this.m4r_1 = subject;
        this.n4r_1 = 0;
      }
      sv() {
        return this.l4r_1;
      }
      p4r() {
        return this.m4r_1;
      }
      o4r() {
        this.n4r_1 = -1;
      }
      *q4r(subject, $completion) {
        this.m4r_1 = subject;
        return yield* this.r4r($completion);
      }
      *r4r($completion) {
        var index = this.n4r_1;
        if (index < 0)
          return this.m4r_1;
        if (index >= this.k4r_1.q2()) {
          this.o4r();
          return this.m4r_1;
        }
        return yield* /*#__NOINLINE__*/proceedLoop(this, $completion);
      }
      *s4r(initial, $completion) {
        this.n4r_1 = 0;
        this.m4r_1 = initial;
        return yield* this.r4r($completion);
      }
    }
    initMetadataForClass($, 'DebugPipelineContext', VOID, VOID, VOID, [1, 0]);
    DebugPipelineContextClass = $;
  }
  return DebugPipelineContextClass;
}
//region block: exports
export {
  DebugPipelineContext as DebugPipelineContext2zfnr2i0vcihk,
};
//endregion

//# sourceMappingURL=DebugPipelineContext.mjs.map
